import {WebHelpers} from "./utils/WebHelpers";
import {AppMessage, AppMessageType} from "./ui/AppMessage";
import * as misc from "./utils/misc";
import {Merchant} from "./Merchant";
//import {Statistics} from "./Statistics"; // use dynamic import because amcharts is too big for non-merchants
import {Pay} from "./Pay";
import {logger} from "./utils/Log";
import {Localizer} from "./Localizer";
import {Landing} from "./Landing";
import {Payment} from "./structs/Payment";
import {AbstractPage} from "./AbstractPage";
import {PlotConfig} from "./Statistics";
import {Timestamps} from "./Timestamps";

export interface AppConfig {
    // PAY page
    pathPay: string;
    pathPayDone: string;
    pathUpdatePayment: string;
    pathPayRefresh: string;
    submitCardToken: string;
    pathCardEvent: string;
    pathFingerprint: string;
    pathPaymentAction: string;
    apiBase: string;
    ref: string; // referer
    reCaptchaKey: string;
    numDecimals: number; // 2
    checkStatusIntervalSec: number;
    maxCheckStatusCount: number;
    customerCount: number;

    // on Pay (payment) page
    fullPage: boolean; // true = full page payment, false = iframe
    payment: Payment;
    gateway: {
        key: string;
    }

    // Account page
    balance: number; // balance in merchant wallet

    // Refund page
    exchangeRate?: number;

    // Statistics pages
    plot: PlotConfig;

    // localizations
    tr: {
        // TODO can be removed in favor of new Localizer.ts
        close: string;
        confirmSignatures: string;
        updating: string;
    }

    cookieLifeDays: number;
    cookiePath: string;
    cookieHost: string;
    siteUrl: string;
}

export type PageType = "landing" | "merchant" | "pay";

export class JqueryApp {
    protected static readonly TEXT_FIELDS = ["wp-address", "private-key", "token-id", "reward-amount",
        "wc-api-key", "wc-api-secret"];

    public readonly $: JQueryStatic;
    protected readonly config: AppConfig;
    protected readonly webHelpers: WebHelpers;
    protected readonly localizer: Localizer;
    protected readonly landing: Landing;
    protected readonly merchant: Merchant;
    protected statistics: AbstractPage; // Statistics // TODO dynamic import type?
    protected readonly pay: Pay;

    protected readonly pageType: PageType;

    constructor($: JQueryStatic) {
        this.$ = $;
        this.config = (window as any).vpayCfg || {};
        if (!this.config.cookieHost)
            this.config.cookieHost = window.location.host;

        this.webHelpers = new WebHelpers(window as any, this.$, this.config);
        const lang = this.webHelpers.getCookie("lng");
        this.localizer = new Localizer(this.webHelpers, lang, `${document.location.origin}/pub/locales/`);
        this.localizer.loadTranslationsFromObject("vpayTr");
        this.localizer.exportTranslationFunctionToWindow();

        AppMessage.setJquery(this.$);
        AppMessage.setLocales(this.config.tr);

        // create the class and bind events based on the page we are on
        this.pageType = this.getPageType();
        logger.info("%s page loading", this.pageType);
        switch (this.pageType)
        {
            case "merchant":
                this.merchant = new Merchant(this);
                (async () => {
                    //const { Merchant } = await import("./Merchant"); // 1KB bundle, not worth splitting
                    //this.merchant = new Merchant(this);

                    if(this.$("#chartdiv").length !== 0) {
                        const { Statistics } = await import("./Statistics"); // 466KB
                        this.statistics = new Statistics(this);
                    }
                })();
                break;
            case "landing":
                this.landing = new Landing(this);
                break;
            case "pay":
                this.pay = new Pay(this);
                break;
            default:
                misc.assertUnreachableCode(this.pageType);
        }
        this.$(() => {
            this.setupBoostrapFramework();
            const ts = new Timestamps(this, 0, "data-unix");
            ts.updateTimestampsRepeating();
            if (this.pageType !== "pay")
                this.webHelpers.removeCookieCustom("__stripe_mid", "/", "." + this.config.cookieHost, true);
        });
    }

    public getConfig() {
        return this.config;
    }

    public getWebHelpers() {
        return this.webHelpers;
    }

    public getTr() {
        return this.localizer;
    }

    // ################################################################
    // ###################### PRIVATE FUNCTIONS #######################

    protected getPageType(): PageType {
        // must be checked before landing-area
        if (this.$("body").hasClass("page-pay") === true)
            return "pay";
        else if (this.$("body").hasClass("landing-area") === true)
            return "landing";
        else if (this.$("body").hasClass("merchant-area") === true)
            return "merchant";
        throw new Error("Unknown page type on body: " + this.$("body").attr("class"));
    }

    protected setupBoostrapFramework() {
        const $ = this.$('[data-toggle="tooltip"]') as any;
        $.tooltip();
    }
}
